import React, { Component } from "react";
import { Col } from "reactstrap";

import AccreditedPharmacySkeleton from "./AccreditedPharmacySkeleton";

export default class SearchAccreditedPharmacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }

  componentDidMount() {
    this.setState({
      list: this.props.stores
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.stores !== state.stores) {
      return {
        list: props.stores,
      };
    }

    return null;
  }

  // Alguns telefones têm rótulo ("Curitiba: (41) ...", "Fax: ..."), então o
  // link usa só os dígitos para o discador não receber texto.
  renderPhoneNumbers(phoneNumber) {
    const phones = Array.isArray(phoneNumber) ? phoneNumber : [phoneNumber];

    return phones.map((phone, index) => (
      <React.Fragment key={index}>
        <a className="text-purple" href={'tel:' + phone.replace(/\D/g, '')}>{phone}</a>
        <br/>
      </React.Fragment>
    ));
  }

  renderEmails(store) {
    const emails = [];

    if (store.email) {
      emails.push({ key: 'email', address: store.email, label: store.email });
    }

    if (store.email_sac) {
      emails.push({ key: 'email_sac', address: store.email_sac, label: 'SAC: ' + store.email_sac });
    }

    // Usa <br/> em vez de <div> porque o conteúdo fica dentro de um <p>.
    return emails.map(email => (
      <React.Fragment key={email.key}>
        <a className="text-purple" href={'mailto:' + email.address}>{email.label}</a>
        <br/>
      </React.Fragment>
    ));
  }

  normalizeUrl(url) {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return 'https://' + url;
  }

  // A planilha do cliente mistura "www.x.com.br" e "https://x.com.br/";
  // o card mostra sempre o endereço sem protocolo e sem barra final.
  formatSiteLabel(url) {
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  render() {
    return (
      <React.Fragment>
        {
          this.state.list.length <= 0 && this.props.loading
          ? <AccreditedPharmacySkeleton />
          : (
            this.state.list.map((store, key) => {
              return (
                <Col xs={9} sm={9} md={9} lg={4} key={key} className="mt-4">
                  <div className="accredited-pharmacy-box text-center hover-effect">
                    <h1>{store.corporateName}</h1>

                    <div className="accredited-pharmacy-box__description">
                      <p>
                        {this.renderPhoneNumbers(store.corporatePhoneNumber)}
                        {store.whatsapp && (
                          <>
                            {/* O wa.me exige o número com código do país (55). */}
                            <a
                              href={'https://wa.me/55' + store.whatsapp.replace(/\D/g, '')}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {store.whatsapp} (WhatsApp)
                            </a>
                            <br/>
                          </>
                        )}
                        {this.renderEmails(store)}
                        {store.site && (
                          <a
                            href={this.normalizeUrl(store.site)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {this.formatSiteLabel(store.site)}
                          </a>
                        )}
                      </p>
                    </div>

                    <div className="accredited-pharmacy-box__footer">
                      Abrangência: {store.coverage}
                    </div>
                  </div>
                </Col>
              )
            })
          )
        }
      </React.Fragment>
    );
  }
}

